import React, { forwardRef, useState } from 'react';
import { readOnlyAction, useAdminAccess } from 'contexts/adminAccess';
import { FieldProps, InjectedFieldProps } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { RewardBadgeDto } from '../../types';
import EditBadgeDialog from './EditBadgeDialog';

type EditBadgeActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardBadgeDto;
};

const EditBadgeActionField = forwardRef<HTMLLIElement, EditBadgeActionFieldProps>(
  ({ record }, ref) => {
    const { canWrite } = useAdminAccess();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
      <>
        <MenuItem ref={ref} onClick={handleOpen}>
          {canWrite ? 'Edit' : 'View'}
        </MenuItem>
        {open && <EditBadgeDialog open={open} onClose={handleClose} badge={record} />}
      </>
    );
  }
);

export default readOnlyAction(EditBadgeActionField);
